import React, { useEffect, useState } from 'react'
import Rating from '@mui/material/Rating';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import moment from 'moment'
import { auth, db } from '../../../../../../firebase';
import Avatar from '@mui/material/Avatar';
import { toast } from 'react-toastify';
import { Modal, Button } from 'react-bootstrap';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import swal from "@sweetalert/with-react";


function stringToColor(string) {
    let hash = 0;
    let i;
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
  }
  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(' ')[0][0]}`,
    };
  }

function Post({ ratedByUid, rating, ratingComment, ratingTime, reviewId, menuId, branchId}) {
    const [reviewer, setReviewer] = useState("")
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [report, setReport] = React.useState('');

    const handleChange = (event) => {
        setReport(event.target.value);
    };

    useEffect(() => {
        db.collection('users').doc(`${ratedByUid}`).onSnapshot((doc) => {
            setReviewer(doc.data());
        });
    }, [])


    const deleteReview = () =>{
        if(window.confirm("Are you sure you want to delete this review?")){
            db.collection("reviews").doc(reviewId).delete().then(function() {
            }).catch(function(error) {
                toast.error("Error removing post: ", error);
            }); 
            toast.success("Your review has been deleted!")   
          }
    }
    const reportReview = () =>{
        if(!report){
            toast.error("Select from the form!")
        }else{
            db.collection("reports").add({
                branchId,
                menuId,
                reporterByUid:auth?.currentUser?.uid,
                report,
                reviewedId:reviewId,
                timestamp: Date.now(),
            }).
            then((e)=> 
            setShow(false),
            setReport(""),
            swal("Your report has been sent to the admin ✔️!")
            )
           
        }
    }
  return (
    <div>
                        <div className="bg-white rounded shadow-sm p-4 mb-4 restaurant-detailed-ratings-and-reviews">
        <div className="reviews-members pt-4 pb-4">
          <div className="media">
            <a>
                {/* <img alt="Generic placeholder image" src="img/user/1.png" className="mr-3 rounded-pill" /> */}
                <Avatar {...stringAvatar(`${reviewer?.displayName}`)}/>
                
                </a>
            <div style={{marginLeft:5}} className="media-body">
              <div className="reviews-members-header">
                <span className="star-rating float-right">
                    <div style={{display:'flex',alignItems:'center'}}>
                    {rating}/5 <Rating name="half-rating-read" value={rating} precision={0.5} readOnly /> 
                    {auth?.currentUser?.uid ?(
                    <>
                                         {ratedByUid === auth?.currentUser?.uid ?(
                    <MoreVertIcon onClick={deleteReview} style={{cursor:'pointer'}}/>
                     ):(
                        <MoreVertIcon onClick={handleShow} style={{cursor:'pointer'}}/>
                     )}
                    </>
                    ):(
                        <MoreVertIcon onClick={() => alert("Kindly Sign In first.\nThanks!")} style={{cursor:'pointer'}}/>  
                    )}


                    </div>
                </span>
                <h6 className="mb-1"><a className="text-black" href="#">{reviewer?.displayName}</a></h6>
                <p className="text-gray">{moment(ratingTime).fromNow()}</p>
              </div>
              <div className="reviews-members-body">
                <p>
                 {ratingComment}                    
                 </p>
              </div>
              <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Report Review!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Which of these has been terminated...</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={report}
          label="Which of these has been terminated..."
          onChange={handleChange}
        >
          <MenuItem value="Abusive Content">Abusive Content</MenuItem>
          <MenuItem value="Pornographic Content">Pornographic Content</MenuItem>
          <MenuItem value="Out of Content">Out of Content </MenuItem>
        </Select>
      </FormControl>
    </Box>
        </Modal.Body>
        <Modal.Footer>
        <Button onClick={reportReview} variant="primary">
          Submit
          </Button>
          <Button variant="primary" onClick={handleClose}>
          Close
          </Button>
        </Modal.Footer>
      </Modal>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  )
}

export default Post